<template>
    <div class="home container">
        <div class="home_box">
            <ul class="home_list list-style flex flex-wrap">
                <li>
                    <router-link class="home_item flex align-center justify-center f28 color-3" to="/form">
                        <img src="@/assets/images/home-img.png">
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Home',
    components: {},
    data() {
        return {

        }
    },

    computed: {
        
    },

    created() {
    },
    mounted () {

    },
    methods: {
        
    }
}
</script>

<style lang="scss" scoped>
.home{
    min-height: 100vh;
    background-color: #F9F9F9;
    background-image: url('~@/assets/bg/home-bg.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
}
.banner {
    height: 3.6rem;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
.home_box{
    padding: 1.84rem .3rem;
}
.home_list{
    li{
        margin-bottom: .1rem;
    }
    .home_item{
        width: 100%;
        height: 3rem;
        cursor: pointer;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
</style>
